module.exports = __webpack_public_path__ + "media/images/link-bidditbe-f0f49a0b23d168b9617f8bdbb7aba9b3.png";